import {FunctionalComponent, h, VNode} from "preact";
import {useEffect} from "preact/hooks";
import {YouTubePlayer} from "./YouTubePlayer";
import {MessageFrame} from "../../components/messageFrame";

export const EmbedBox: FunctionalComponent<{ msgID: string; videoURL: string; tickCallback: () => void }> = ({
                                                                                                                 msgID,
                                                                                                                 videoURL,
                                                                                                                 tickCallback
                                                                                                             }) => {

    let content: VNode;

    useEffect(() => {
        // log.info(`use effect for ${msgText}`);
        /** advance queue */
        tickCallback();
    }, [msgID]);

    if (videoURL.indexOf('youtube') !== -1) {
        content = <YouTubePlayer msgID={msgID} videoURL={videoURL} tickCallback={tickCallback} />
    } else if (videoURL.indexOf('soundcloud') > -1) {
        //TODO had to remove allow="autoplay" because it prevented ts from building
        content = <iframe className="soundcloud optanon-category-C0003" style="height:12rem"
                          src={`${videoURL}&show_user=false&auto_play=true&sharing=false&download=false&show_artwork=false&color=%23E6007E&show_teaser=false`}
                          frameBorder="0" allowFullScreen />
    } else {
        content = <iframe src={videoURL} frameBorder="0" allowFullScreen />
    }

  return <MessageFrame clsName='video'>
            {content}
         </MessageFrame>;
};
